import { CurrentUser, Passkey } from '../types/auth';
import { api, seg } from './client';

/**
 * The two "options" calls return the WebAuthn library's own JSON text verbatim
 * (parsed once here as a plain string by the fetch wrapper) — pass it straight to
 * `PublicKeyCredential.parseCreationOptionsFromJSON`/`parseRequestOptionsFromJSON`.
 */
export const passkeyRegistrationOptions = (): Promise<string> =>
  api.post<string>('/auth/passkey/registration/options', {});

export const finishPasskeyRegistration = (credential: string, label: string): Promise<Passkey> =>
  api.post<Passkey>('/auth/passkey/registration', { credential, label });

export const listPasskeys = (): Promise<Passkey[]> => api.get<Passkey[]>('/auth/passkey/credentials');

export const deletePasskey = (id: string): Promise<void> =>
  api.delete(`/auth/passkey/credentials/${seg(id)}`);

export const passkeyLoginOptions = (): Promise<string> =>
  api.post<string>('/auth/passkey/login/options', {});

export const finishPasskeyLogin = (credential: string): Promise<CurrentUser> =>
  api.post<CurrentUser>('/auth/passkey/login', { credential });
